var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgClose = function SvgClose(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1000 1000",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M998.1 201.5 796.1 4 500 300.4 201.5 1.9 4 203.9l296.4 296.2L1.9 798.9 203.4 996 500 699.5l298.9 298.6L996 796.6 699.6 500z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgClose);
export default ForwardRef;